import { render, staticRenderFns } from "./newDesc1.vue?vue&type=template&id=e1ce32ea&scoped=true"
import script from "./newDesc1.vue?vue&type=script&lang=js"
export * from "./newDesc1.vue?vue&type=script&lang=js"
import style0 from "./newDesc1.vue?vue&type=style&index=0&id=e1ce32ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ce32ea",
  null
  
)

export default component.exports